// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__-lMco","label":"SetPasswdForm_label__2jH5R"};